import React from 'react';
import './Product.css';

const Product = (props) => {
    // console.log(props.handleAddProduct);
    const {img,name,seller,price,stock} = props.product;
    return (
        <div className="product">
            <div>
                <img src={img} alt="" className='productImg'/>
            </div>
            <div>
                <h4 className='productName'>{name}</h4>
                <p><small>by: {seller}</small></p>
                <p>${price}</p>
                <p><small>Only {stock} left in stock - <strong>Order Soon</strong></small></p>
                <button 
                    className='productBtn' 
                    onClick={() => props.handleAddProduct(props.product)
                    }>Add to Cart</button>
            </div>
        </div>
    );
};

export default Product;